import React from 'react';

const cx = (...a) => a.filter(Boolean).join(' ');

const gapToClass = (gap) => {
    if (typeof gap === 'number') return `gap-${gap}`;
    const map = {
        none: 'gap-0',
        xs: 'gap-1',
        sm: 'gap-2',
        md: 'gap-3',
        lg: 'gap-4',
        xl: 'gap-6',
    };
    return map[gap] || map.md;
};

const alignToClass = {
    start: 'items-start',
    center: 'items-center',
    end: 'items-end',
    baseline: 'items-baseline',
    stretch: 'items-stretch',
};

const justifyToClass = {
    start: 'justify-start',
    center: 'justify-center',
    end: 'justify-end',
    between: 'justify-between',
    around: 'justify-around',
    evenly: 'justify-evenly',
};

export default function Row({
    as: As = 'div',
    children,
    gap = 'md',
    align = 'center',
    justify = 'start',
    wrap = false,
    fullWidth = true,
    divider = false,
    className = '',
    style,
}) {
    const classes = cx(
        'flex flex-row',
        fullWidth && 'w-full',
        gapToClass(gap),
        alignToClass[align] || '',
        justifyToClass[justify] || '',
        wrap ? 'flex-wrap' : 'flex-nowrap',
        divider && 'divide-x divide-gray-200',
        className
    );

    return (
        <As className={classes} style={style}>
            {children}
        </As>
    );
}